define('drops/simpleSpreadsheet/simpleSpreadsheet',[
    'jquery',
    'lq/drop',
    'lq/style',
    'drops/simpleSpreadsheet/simpleSpreadsheetRow'
], function ($, Drop, Style, SimpleSpreadsheetRow) {
    'use strict';

    var defaults = {
        data: {
            defaultNumberOfRows: 100,
            columns: []
        }
    };

    function SimpleSpreadsheet(options) {
        Drop.call(this, $('<div class="simple-spreadsheet"/>'), defaults, options);

        this.selectedRows = [];
        this.lastTotal = null;
        this.deletedRowIds = [];

        this.$rows = $('<div class="spreadsheet-table" />')
            .appendTo(this.$element);

        Style.renderStyles(this);

        var self = this;
        this.columnUpdated = _.debounce(function (indexOfColumn) {
            if (indexOfColumn !== Number(self.data.eventArgumentColumn))
                return;
            self.triggerUpdated();
        }, 500);
    };

    Drop.extend(SimpleSpreadsheet, Drop);

    SimpleSpreadsheet.typeName = 'SimpleSpreadsheet';
    
    SimpleSpreadsheet.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.datasources.registerDatasourceListener(
            this.data.datasource,
            this.loadDataFromDatasource.bind(this),
            $.noop);

        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);

        this.applyPosition();
        
        this.createDefaultNumberOfRows();

        if (this.rows.length > 0)
            this.setSelectedRow(this.rows[0]);
    };
    
    SimpleSpreadsheet.prototype.createDefaultNumberOfRows = function () {
        this.rows = _(this.data.defaultNumberOfRows).times(this.createRow.bind(this));
        this.$rows.append(_.pluck(this.rows, '$element'));
    };

    SimpleSpreadsheet.prototype.createRow = function () {
        var row = new SimpleSpreadsheetRow(this);

        _.each(this.data.columns, function (column, i) {
            if (column.width === null || column.width === undefined)
                return;

            var $cell = row.$element
                .children(':eq(' + i + ')');

            // note: setting width to 0 does not work in every browser
            if (column.width === 0)
                $cell.css('display', 'none');
            else
                $cell.css('width', column.width + 'px');
        });

        return row;
    };

    SimpleSpreadsheet.prototype.loadDataFromDatasource = function (data) {
        this.deletedRowIds = [];

        var numberOfRequiredLines = this.getNumberOfRequiredLines(data);

        if (this.rows.length < numberOfRequiredLines) {
            var extraRows = _(numberOfRequiredLines - this.rows.length).times(this.createRow.bind(this));
            this.rows.push.apply(this.rows, extraRows);
            this.$rows.append(_.pluck(extraRows, '$element'));
        } else if (this.rows.length > numberOfRequiredLines) {
            this.rows.splice(numberOfRequiredLines);
            this.$rows
                .children()
                .filter(":gt(" + (numberOfRequiredLines-1) + ")")
                .remove();
        }

        var rows = this.rows;
        var rowNumberOutput = this.data.rowNumberOutput;
        var idOutput = this.data.idOutput;
        var sortedResults = _.sortBy(data.Results, rowNumberOutput);

        _.each(sortedResults, function (result, i) {
            rows[i].setData(result);
            rows[i].rowId = result[idOutput];
        });

        var rowToFocus = _.find(rows, function(row) {
            return row.isEmpty();
        });
        if (!rowToFocus)
            rowToFocus = rows[0];

        this.setSelectedRow(rowToFocus);

        this.triggerUpdated();
    };

    SimpleSpreadsheet.prototype.getNumberOfRequiredLines = function(data) {
        return data.Results.length === 0 ? this.data.defaultNumberOfRows : data.Results.length;
    };

    SimpleSpreadsheet.prototype.setSelectedRow = function (row) {
        if (this.selectedRows.length === 1 && this.selectedRows[0] === row) return;

        _.each(this.selectedRows, function(row) {
            row.dehighlight();
        }); 

        this.selectedRows = [row];

        this.updateRowIndexParameter(row);

        row.highlight();
        
        var rowToScrollTo = _.first(this.rows) === row ? row : this.rows[_.indexOf(this.rows, row) - 1];
        var scrollTop = this.$element.scrollTop() + rowToScrollTo.$element.position().top;
        
        if (this.$element.scrollTop() > scrollTop || scrollTop > this.$element.scrollTop() + this.$element.height())
            this.$element.scrollTop(scrollTop);
    };

    SimpleSpreadsheet.prototype.updateSelectedRows = function(row) {
        if (this.isRowSelected(row)) {
            this.selectedRows = _.reject(this.selectedRows, function(selectedRow) {
                return selectedRow === row;
            });
            row.dehighlight();
        } else {
            this.selectedRows.push(row);
            row.highlight();
            this.updateRowIndexParameter(row);
        }
    };

    SimpleSpreadsheet.prototype.isRowSelected = function(row) {
        return _.indexOf(this.selectedRows, row) !== -1;
    };

    SimpleSpreadsheet.prototype.updateRowIndexParameter = function (row) {
        if (!this.data.currentRowParameter)
            return;

        this.piping.parameters.locals.setValue(this.data.currentRowParameter, _.indexOf(this.rows, row));
    };

    SimpleSpreadsheet.prototype.triggerUpdated = function () {
        if (!this.isEventEnabled('updated'))
            return;

        var newTotal = this.getTotalForEvent();
        if (this.lastTotal === newTotal)
            return;

        this.triggerEvent(this.data.eventing['updated'].raisedEventName, newTotal);
        this.lastTotal = newTotal;
    };

    SimpleSpreadsheet.prototype.getTotalForEvent = function () {
        var eventArgumentColumn = this.data.eventArgumentColumn;

        if (this.data.eventArgumentFunction === 'sum') {
            var precision = Math.pow(10, this.formatter.decimalPrecision);
            var total = _.reduce(this.rows, function (acc, row) {
                return acc + (row.getNumericValueOf(eventArgumentColumn) * precision || 0);
            }, 0);
            total = Math.round(total);
            total = total / precision;
            return total;
        }

        throw new Error('Invalid function');
    };
    
    SimpleSpreadsheet.prototype.setValue = function (update) {
        if (!update.value) return;

        var startRowIndex = this.selectedRows.length > 0 ? this.getFirstSelectedIndex() : 0;
        var lines = update.value.split('\n');
        var requiredLength = startRowIndex + lines.length;

        if (requiredLength > this.rows.length)
            this.addExtraRows(requiredLength - this.rows.length);

        for (var i = 0; i < lines.length; i++) {
            var line = lines[i];
            var row = this.rows[i + startRowIndex];
            if(row) row.paste(line);
        }

        var nextSelectedRow = this.rows[startRowIndex + lines.length];
        if (nextSelectedRow)
            this.setSelectedRow(nextSelectedRow);
        else
            this.setSelectedRow(_.last(this.rows));

        this.triggerUpdated();
    };

    SimpleSpreadsheet.prototype.getFirstSelectedIndex = function() {
        return _.chain(this.selectedRows)
            .map(this.getIndexOfRow.bind(this))
            .min()
            .value();
    };

    SimpleSpreadsheet.prototype.addExtraRows = function(numberOfExtraRows) {
        var self = this;
        _.each(_.range(numberOfExtraRows), function () {
            var row = self.createRow();
            self.rows.push(row);
            self.$rows.append(row.$element);
        });
    };

    SimpleSpreadsheet.prototype.getBatchOfCommands = function () {
        if (!this.rows) return [];

        var rowNumberAttribute = this.data.rowNumberAttribute;
        var parentAttribute = this.data.parentAttribute;
        var parentIdParameter = this.data.parentIdParameter;
        var parameters = this.piping.parameters;
        return {
            eventActionType: 'Batch',
            command: this.data.id,
            batch: _.map(this.rows, function (row, i) {
                var data = row.getData();
                data[rowNumberAttribute] = i;

                if (!row.rowId)
                    data[parentAttribute] = parameters.getValue(parentIdParameter);

                return {
                    entityId: row.rowId,
                    data: data
                };
            }),
            deletes: this.deletedRowIds
        };
    };

    SimpleSpreadsheet.prototype.receiveBatchOfCommandsResult = function (identifiers) {
        var rows = this.rows;
        _.each(identifiers, function(identifier, i) {
            rows[i].rowId = identifier;
        });
    };
    
    SimpleSpreadsheet.prototype.moveToNextRow = function(triggerRow, indexOfColumn) {
        var indexOfTrigger = this.getIndexOfRow(triggerRow);

        if (indexOfTrigger === this.rows.length - 1)
            return;

        var nextRow = this.rows[indexOfTrigger + 1];
        this.setSelectedRow(nextRow);

        nextRow.focusInputField(indexOfColumn);
    };

    SimpleSpreadsheet.prototype.licquidMethod_insertRow = function() {
        var oneOrMoreRowsAreSelected = this.selectedRows.length > 0;
        var index = oneOrMoreRowsAreSelected
            ? this.getIndexOfRow(this.selectedRows[0])
            : 0;

        var newRow = this.createRow();

        if (oneOrMoreRowsAreSelected && this.selectedRows[0] === _.last(this.rows)) {
            this.rows.push(newRow);

            this.$rows.children().eq(index)
                .after(newRow.$element);
        } else {
            this.rows.splice(index, 0, newRow);

            if (index === 0)
                this.$rows.prepend(newRow.$element);
            else
                this.$rows.children().eq(index)
                    .before(newRow.$element);
        }

        this.setSelectedRow(newRow);
        newRow.focusFirstInputField();
    };

    SimpleSpreadsheet.prototype.licquidMethod_deleteRow = function () {
        if (this.selectedRows.length === 0)
            return;

        var lastSelectedIndex = this.getLastSelectedIndex();
        
        _.each(this.selectedRows, this.deleteRow.bind(this));

        if (this.rows.length !== 0) {
            var nextIndexToFocus = this.rows.length > lastSelectedIndex ? lastSelectedIndex : this.rows.length - 1;
            var newRowToFocus = this.rows[nextIndexToFocus];
            this.setSelectedRow(newRowToFocus);
            newRowToFocus.focusFirstInputField();
        } else {
            this.selectedRow = [];
        }

        this.triggerUpdated();
    };

    SimpleSpreadsheet.prototype.getLastSelectedIndex = function() {
        return _.chain(this.selectedRows)
            .map(this.getIndexOfRow.bind(this))
            .max()
            .value();
    };

    SimpleSpreadsheet.prototype.deleteRow = function(row) {
        row.$element.remove();
        
        if (row.rowId)
            this.deletedRowIds.push(row.rowId);

        var index = this.getIndexOfRow(row);
        this.rows.splice(index, 1);
    };

    SimpleSpreadsheet.prototype.getIndexOfRow = function(row) {
        return this.rows.indexOf(row);
    };

    SimpleSpreadsheet.prototype.clearValue = $.noop;

    return SimpleSpreadsheet;
});
